import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { appCatalogUrl } from "../urls";
import mockAppTrustData from "./mockAppTrustData";
export const fetchAppTrustData = (mpacBaseUrl, appKey) => fetchOk(appCatalogUrl(mpacBaseUrl, "/apps/".concat(appKey, "/trust")))
// TODO: Remove mock & uncomment this once the API is ready
// Update respective test to remove .skip
// .then(response => response.json())
.then(() => mockAppTrustData).catch(() => mockAppTrustData);